import { IBaseEditorProps, BaseEditor } from "./BaseEditor";

import { ISelectSpecificProps } from "./Select";

import * as React from "react";

import { SelectFactory } from "./Factories/SelectFactory";

import { isNotEmpty } from "./Validation/RawValueRules";

import { Guid } from "../Utils/Guid";
import * as classNames from "classNames";

export interface ISelectEditorProps<TOption>
    extends IBaseEditorProps,
        ISelectSpecificProps<TOption>,
        React.Props<SelectEditor<TOption>> {}

export class SelectEditor<TOption> extends BaseEditor<ISelectEditorProps<TOption>> {
    constructor(props: ISelectEditorProps<TOption>) {
        super(props);
    }

    public componentDidMount(): void {
        this.bindLabelToInput();
    }

    public render(): JSX.Element {
        const wrapperCss = classNames("form-group", this.props.cssWrapper, {
            error: this.state.typingFinished && (!this.state.isValid || !this.state.isValidOutside),
            valid: this.state.typingFinished && this.state.isValid && this.state.isValidOutside,
        } as any);
        return (
            <div className={wrapperCss} ref={(elem: HTMLElement) => (this.wrapperRef = elem)}>
                {this.props.label && (
                    <div className={"control-label"}>
                        <label htmlFor={this.state.inputGroupId}>{this.props.label}</label>
                        {this.getTooltip()}
                    </div>
                )}

                {this.props.inputGridClasses && (
                    <div className="row">
                        <div className={this.props.inputGridClasses}>
                            <div className="controls-select controls-wrap">
                                {this.getInput()}
                                {this.getValidationErrorsContainer()}
                            </div>
                        </div>
                    </div>
                )}

                {!this.props.inputGridClasses && (
                    <div className="controls-select controls-wrap">
                        {this.getInput()}
                        {this.getValidationErrorsContainer()}
                    </div>
                )}

                {this.getInfoText()}
            </div>
        );
    }

    protected getInput(): JSX.Element {
        const Select = SelectFactory.create<TOption>();
        return (
            <Select
                {...(this.props as any)}
                id={this.state.inputGroupId}
                onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                    this.handleValidationResultChange(isValid, errors, showValidationMessages)
                }
                ariaDescribedby={this.props.ariaInvalidCanBeShown && this._errorMessageId + " " + this._infoTextId}
                onBlur={(value) => this.onBlur(value)}
                ariaInvalidCanBeShown={this.state.typingFinished}
                ariaInvalidShouldBeShown={!this.state.isValidOutside}
            />
        );
    }

    private onBlur(value: TOption): void {
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private bindLabelToInput(): void {
        let id: string;
        let propId: string = null;
        if (this.props.hasOwnProperty("id")) {
            propId = this.props.id;
        }

        id = isNotEmpty(propId) ? propId : Guid.getNext();
        this.setState({ inputGroupId: id });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);
        if (this.props.onValidationResultChange) {
            this.props.onValidationResultChange(isValid, errors, showValidationMessages);
        }

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
